app.controller('CIF-CTRL', ['$scope', '$window', '$q', '$filter', 'appFactory',
    function ($scope, $window, $q, $filter, appFactory) {

        $scope.CIFInvestor = {
            Sex: '',
            Religion: '',
            MaritalStatus: '',
            Education: '',
            ResidencyStatus: '',
        }
        let tmpdate = new Date();
        tmpdate.setFullYear(tmpdate.getFullYear() - 17);
        $scope.maxDate = tmpdate.toISOString().slice(0, 10);
        $scope.Kewarganegaraan = 'WNI / Indonesian';
        $scope.KewarganegaraanOption = ['WNI / Indonesian'];
        $scope.IDLength = 16;
        $scope.chkSeumurHidup = true;
        $scope.DisabledSeumurHidup = true;

        $scope.chkSpouseSeumurHidup = true;
        $scope.SpouseDisabledSeumurHidup = true;

        $scope.IDCardCitySelected = '';
        $scope.DomicileCitySelected = '';
        $scope.NationalitySelected = '';
        $scope.IDCardCountrySelected = '';
        $scope.IDCardKecamatanSelected = '';
        $scope.IDCardOK = false;

        $scope.ListNationality = [];
        $scope.ListLookup = [];
        $scope.ListReligion = [];
        $scope.ListMarital = [];
        $scope.ListEducation = [];
        $scope.ListResidencyStatus = [];
        $scope.ListKecamatan = [];
        $scope.ListKecamatanDomicile = [];
        $scope.ListKecamatanAll = [];
        $scope.ListKelurahan = [];
        $scope.ListKelurahanDomicile = [];

        $scope.checkIDCardNumber = function () {
            if ($scope.CIFInvestor.IDCardNumber) {

                appFactory.getData(`service/client.svc/checkIDCardNumber?KTP=${$scope.CIFInvestor.IDCardNumber}`).then(function (data) {

                    if (data.status == 200) {

                        if (data.data.d != null) {

                            var obj = data.data.d;
                            if (obj.key && obj.key == 1) {

                                $scope.myForm1.$valid = false;
                                $scope.IDCardOK = false;
                                $scope.myForm1.txtNoIDCard.$invalid = true;

                                var SWALtranslate = $scope.SWALtranslate(obj.value);
                                Swal.fire(SWALtranslate.message, SWALtranslate.title, "error");
                            } else {
                                $scope.IDCardOK = true;
                                $scope.myForm1.txtNoIDCard.$invalid = false;
                            }
                        }
                    }
                });
            }
        }

        $scope.KewarganegaraanChange = function () {

            if ($scope.Kewarganegaraan == 'WNI / Indonesian') {

                $scope.IDLength = 16;
                $scope.chkSeumurHidup = true;
                $scope.DisabledSeumurHidup = true;
                $scope.CIFInvestor.Nationality = 102;
                $scope.CIFInvestor.IDCardCountry = 102;
                $scope.CIFInvestor.CopyID = true;
                $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
            }
            else if ($scope.Kewarganegaraan == 'Lainnya / Others') {

                $scope.IDLength = 8;
                $scope.chkSeumurHidup = false;
                $scope.DisabledSeumurHidup = true;
                $scope.CIFInvestor.Nationality = 0;
                $scope.CIFInvestor.IDCardCountry = 0;
                $scope.CIFInvestor.CopyID = false;
                $scope.CIFInvestor.IDCardExpireDate = '';
                $scope.CIFInvestor.IDCardCity = 0;
                $scope.CIFInvestor.IDCardKecamatan = '';
                $scope.CIFInvestor.IDCardKelurahan = '';
                $scope.CIFInvestor.IDCardRT = '';
                $scope.CIFInvestor.IDCardRW = '';
                $scope.CIFInvestor.IDCardAddress = '';
                $scope.IDCardCitySelected = '';
            }
        }

    

        $scope.selectNationality = function (item, model, label, event) {
            if (item.CIFCountryNID) {

                $scope.CIFInvestor.Nationality = item.CIFCountryNID;
                $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
                $scope.NationalitySelected = item;
                $scope.IDCardCountrySelected = item;
            }
        };

        $scope.selectSpouseNationality = function (item, model, label, event) {
            if (item.CIFCountryNID) {

                $scope.CIFInvestor.SpouseNationality = item.CIFCountryNID;
                $scope.SpouseNationalitySelected = item;
            }
        };

        $scope.selectIDCardCountry = function (item, model, label, event) {
            if (item.CIFCountryNID)
                $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;

        };

        $scope.selectIDCardCity = function (item, model, label, event) {
            $scope.ListKecamatan = '';
            $scope.ListKelurahan = '';

            if (item.CIFProvinceCityNID) {

                $scope.CIFInvestor.IDCardCity = item.CIFProvinceCityNID;

                appFactory.getData(`service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatan = data.data.d;
                        $scope.kecamatanChange();
                    }
                });
            }

        };

        $scope.selectDomicileCity = function (item, model, label, event) {
            $scope.ListKecamatanDomicile = '';
            $scope.ListKelurahanDomicile = '';

            if (item.CIFProvinceCityNID) {
                $scope.CIFInvestor.DomicileCity = item.CIFProvinceCityNID;

                appFactory.getData(`service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${item.CIFProvinceCityNID}`).then(function (data) {

                    if (data.status == 200) {

                        $scope.ListKecamatanDomicile = data.data.d;
                        $scope.kecamatanChange();
                    }
                });
            }
        };

        $scope.kecamatanChange = function () {

            if ($scope.CIFInvestor.IDCardKecamatan)
                $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
        }

        $scope.kelurahanChange = function () {

            if ($scope.CIFInvestor.IDCardKelurahan) {

                let temp = $filter('filter')($scope.ListKecamatan, { Kelurahan: $scope.CIFInvestor.IDCardKelurahan }, true);
                if (temp)
                    $scope.CIFInvestor.IDCardPostalCode = temp[0].PostalCode;

            }
        }

        $scope.kecamatanDomicileChange = function () {
            if ($scope.CIFInvestor.DomicileKecamatan)
                $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
        }

        $scope.kelurahanDomicileChange = function () {
            if ($scope.CIFInvestor.DomicileKelurahan) {
                let temp = $filter('filter')($scope.ListKecamatanDomicile, { Kelurahan: $scope.CIFInvestor.DomicileKelurahan }, true);
                if (temp)
                    $scope.CIFInvestor.DomicilePostalCode = temp[0].PostalCode;
            }
        }

        $scope.CopyFromID = function () {
            if ($scope.CIFInvestor.CopyID) {

                $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
                $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
                $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
                $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
                $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
                $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
                $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
                $scope.DomicileCitySelected = $scope.IDCardCitySelected;
            } else {

                $scope.CIFInvestor.DomicilePostalCode = '';
                $scope.CIFInvestor.DomicileAddress = '';
                $scope.CIFInvestor.DomicileRT = '';
                $scope.CIFInvestor.DomicileRW = '';
                $scope.CIFInvestor.DomicileKelurahan = '';
                $scope.CIFInvestor.DomicileKecamatan = '';
                $scope.CIFInvestor.DomicileCity = 0;
                $scope.DomicileCitySelected = '';
            }
        };

        $scope.mustSelect = function (event, field) {

            if (event.keyCode == 27) {

                let returnValue = true;
                switch (field) {

                    case 'IDCard': $scope.CIFInvestor.IDCardCity = ''; returnValue = false;
                        break;
                    case 'Domicile': $scope.CIFInvestor.DomicileCity = ''; returnValue = false;
                        break;
                    case 'Correspondence': $scope.CIFInvestor.CorrespondenceCity = ''; returnValue = false;
                        break;
                    default:
                        break;
                }
                return returnValue;
            }
            return true;
        }

        var allPromise = $q.all([
            $scope.retrieveSessions(),

            appFactory.getData(`service/client.svc/GetCIFCountry`).then(function (data) {

                if (data.status == 200) {

                    $scope.ListNationality = data.data.d;
                }
            }),

            appFactory.getData(`service/client.svc/GetCIFCountryAll`).then(function (data) {

                if (data.status == 200) {

                    $scope.ListCountry = data.data.d;
                }
            }),

            appFactory.getData(`service/client.svc/GetCIFProvinceCity`).then(function (data) {

                if (data.status == 200) {

                    $scope.ListProvinceCity = data.data.d;
                }
            }),

            appFactory.getData(`service/client.svc/GetCIFLookup`).then(function (data) {

                if (data.status == 200) {

                    $scope.ListLookup = data.data.d;
                    if ($scope.ListLookup) {

                        $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                        $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                        $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
                        $scope.ListResidencyStatus = $filter('filter')($scope.ListLookup, { CIFLookupID: 'ResidencyStatus' }, true);

                    }
                }
            })
        ]);

        allPromise.then(function () {

            appFactory.getData(`service/client.svc/getCIF`).then(function (data) {

                if (data.status == 200) {

                    if (data.data.d.Email != null) {

                        var obj = data.data.d;
                        $scope.CIFInvestor = data.data.d;
                        $scope.CIFInvestor.Stage = 1;

                        if ($scope.CIFInvestor.Sex == 0)
                            $scope.CIFInvestor.Sex = '';

                        if ($scope.CIFInvestor.Religion == 0)
                            $scope.CIFInvestor.Religion = '';

                        if ($scope.CIFInvestor.MaritalStatus == 0)
                            $scope.CIFInvestor.MaritalStatus = '';

                        if ($scope.CIFInvestor.Education == 0)
                            $scope.CIFInvestor.Education = '';

                        if ($scope.CIFInvestor.ResidencyStatus == 0)
                            $scope.CIFInvestor.ResidencyStatus = '';

                        if (data.data.d.BirthDate)
                            $scope.CIFInvestor.BirthDate = new Date(data.data.d.BirthDate);

                      
                        if (data.data.d.ResidencyNStatusDate)
                            $scope.CIFInvestor.ResidencyNStatusDate = new Date(data.data.d.ResidencyNStatusDate);

                        if (data.data.d.IDCardCity) {

                            $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.IDCardCity }, true)[0];

                            appFactory.getData(`service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${data.data.d.IDCardCity}`).then(function (data) {

                                if (data.status == 200) {

                                    $scope.ListKecamatan = data.data.d;
                                    if ($scope.ListKecamatan)
                                        $scope.ListKelurahan = $filter('filter')($scope.ListKecamatan, { Kecamatan: $scope.CIFInvestor.IDCardKecamatan }, true);
                                }
                            })
                        }

                        if (data.data.d.DomicileCity) {

                            $scope.DomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.DomicileCity }, true)[0];

                            appFactory.getData(`service/client.svc/GetCIFKecamatanByCityNID?CIFCityNID=${data.data.d.DomicileCity}`).then(function (data) {

                                if (data.status == 200) {

                                    $scope.ListKecamatanDomicile = data.data.d;
                                    if ($scope.ListKecamatanDomicile)
                                        $scope.ListKelurahanDomicile = $filter('filter')($scope.ListKecamatanDomicile, { Kecamatan: $scope.CIFInvestor.DomicileKecamatan }, true);
                                }
                            });
                        }

                        if (data.data.d.Nationality) {

                            if (data.data.d.Nationality == 102) {

                                $scope.IDLength = 16;
                                $scope.chkSeumurHidup = true;
                                $scope.DisabledSeumurHidup = true;
                                $scope.CIFInvestor.Nationality = 102;
                                $scope.CIFInvestor.IDCardCountry = 102;
                                $scope.Kewarganegaraan = $scope.KewarganegaraanOption[0];
                                $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
                            } else {

                                $scope.IDLength = 8;
                                $scope.chkSeumurHidup = false;
                                $scope.DisabledSeumurHidup = true;
                                $scope.Kewarganegaraan = $scope.KewarganegaraanOption[1];
                                $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.Nationality }, true)[0];
                                $scope.IDCardCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: data.data.d.IDCardCountry }, true)[0];

                                if (data.data.d.IDCardExpireDate)
                                    $scope.CIFInvestor.IDCardExpireDate = new Date(data.data.d.IDCardExpireDate);
                            }
                        } else {
                            $scope.KewarganegaraanChange();
                        }

                      

                        if (data.data.d.CopyID)
                            $scope.CopyFromID();

                        //var SWALtranslate = $scope.SWALtranslate('preparationinfouploadphotocif1');

                        //if ($scope.languageSelected.lang == 'id') {
                        //    Swal.fire({
                        //        title: SWALtranslate.title,
                        //        text: 'Ketentuan untuk ambil gambar',
                        //        imageUrl: 'img/logo/Unggah Foto.png',
                        //        imageAlt: 'Preparation',
                        //        imageHeight: 250,
                        //        animation: false
                        //    });

                        //} 
                        
                        //if ($scope.languageSelected.lang == 'en') {
                        //    Swal.fire({
                        //        title: SWALtranslate.title,
                        //        text: SWALtranslate.message,
                        //        imageUrl: 'img/logo/Upload Photo.png',
                        //        imageAlt: 'Preparation',
                        //        imageHeight: 250,
                        //        animation: false
                        //    });
                        //}
                    }
                }
            });
        });

        $scope.prepareData = function () {

            if ($scope.CIFInvestor.CopyID) {

                $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
                $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
                $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
                $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
                $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
                $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
                $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
                $scope.DomicileCitySelected = $scope.IDCardCitySelected;
            }

            if ($scope.CIFInvestor.AccountStatus)
                $scope.CIFInvestor.AccountStatus = Number($scope.CIFInvestor.AccountStatus);

            //if ($scope.CIFInvestor.Sex)
            //    $scope.CIFInvestor.Sex = Number($scope.CIFInvestor.Sex);

            //if ($scope.CIFInvestor.Religion)
            //    $scope.CIFInvestor.Religion = Number($scope.CIFInvestor.Religion);

            //if ($scope.CIFInvestor.MaritalStatus)
            //    $scope.CIFInvestor.MaritalStatus = Number($scope.CIFInvestor.MaritalStatus);

            //if ($scope.CIFInvestor.Education)
            //    $scope.CIFInvestor.Education = Number($scope.CIFInvestor.Education);

            if ($scope.CIFInvestor.Nationality)
                $scope.CIFInvestor.Nationality = Number($scope.CIFInvestor.Nationality);

            if ($scope.CIFInvestor.IDCardCountry)
                $scope.CIFInvestor.IDCardCountry = Number($scope.CIFInvestor.IDCardCountry);

            if ($scope.CIFInvestor.IDCardCity)
                $scope.CIFInvestor.IDCardCity = Number($scope.CIFInvestor.IDCardCity);

            if ($scope.CIFInvestor.DomicileCity)
                $scope.CIFInvestor.DomicileCity = Number($scope.CIFInvestor.DomicileCity);

            if ($scope.CIFInvestor.Education != 1)
                $scope.CIFInvestor.EducationText = '';

            var language;
            if (window.navigator.languages) {

                language = window.navigator.languages[0];
            } else {

                language = window.navigator.userLanguage || window.navigator.language;
            }

            $scope.CIFInvestor.Language = language;

            var date1 = $filter('date')(new Date($scope.CIFInvestor.BirthDate), 'yyyy-MM-dd');

            if ($scope.CIFInvestor.BirthDate) {

                $scope.CIFInvestor.ClientBirthDate1 = $scope.CIFInvestor.BirthDate.toLocaleDateString('en-US');
                $scope.CIFInvestor.ClientBirthDate2 = $scope.CIFInvestor.BirthDate;
                $scope.CIFInvestor.ClientBirthDate3 = date1;
            }
        }

        $scope.submit = function () {
            $scope.prepareData();
            // dynamic sweet alert post to app.js
            // 1: set the url of post or get request
            // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
            // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
            // 4: set the method to $http request = "GET" / "POST"
            // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
            // 6: if success or no error returns then...
            var urlsvc = 'service/client.svc/SaveCIF'; // 1 
            var preconfirmtranslate = "submitCif1"; // 2
            var postData = { cifdata: $scope.CIFInvestor } // 3
            var method = "POST" // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

                if (issuccess) // 6
                    $window.location.href = "#/cif/data-pekerjaan";
            });
        }

        $scope.validationinput = function () {

            var errorForm = $scope.myForm1.$error.required
            var validation = $scope.myForm1.$valid;
            var message = [];
            //console.log('error :', errorForm);

            if (errorForm) {
                for (let i = 0; i < errorForm.length; i++) {
                    //message += errorForm[i].$name + " , ";
                    message.push(errorForm[i].$name);
                }

                if ($scope.CIFInvestor.IDCardNumber == null)
                    $scope.IDCardOK = false;

                if ($scope.CIFInvestor.FirstName != null                      //Data Pribadi Pemohon
                    && $scope.Kewarganegaraan != null
                    && $scope.SpouseKewarganegaraan != null
                    && $scope.CIFInvestor.IDCardNumber != null
                    && $scope.CIFInvestor.SpouseName != null
                    && $scope.CIFInvestor.SpouseRelationship != null
                    && $scope.CIFInvestor.MotherName != null
                    && $scope.CIFInvestor.Sex != null
                    && $scope.CIFInvestor.BirthPlace != null
                    && $scope.CIFInvestor.BirthDate != null
                    && $scope.CIFInvestor.Religion != null
                    && $scope.CIFInvestor.MaritalStatus != null
                    && $scope.CIFInvestor.Education != null
                    && $scope.CIFInvestor.EducationText != null
                    && $scope.CIFInvestor.ResidencyStatus != null
                    && $scope.CIFInvestor.IDCardCitySelected != null    //Alamat Sesuai Identitas
                    && $scope.CIFInvestor.IDCardKecamatan != null
                    && $scope.CIFInvestor.IDCardKelurahan != null
                    && $scope.CIFInvestor.IDCardRT != null
                    && $scope.CIFInvestor.IDCardRW != null
                    && $scope.CIFInvestor.IDCardPostalCode != null
                    && $scope.CIFInvestor.IDCardAddress != null
                    && $scope.DomicileCitySelected != null              //Alamat Domisili   
                    && $scope.CIFInvestor.DomicileKecamatan != null
                    && $scope.CIFInvestor.DomicileKelurahan != null
                    && $scope.CIFInvestor.DomicileRT != null
                    && $scope.CIFInvestor.DomicileRW != null
                    && $scope.CIFInvestor.DomicilePostalCode != null
                    && $scope.CIFInvestor.DomicileAddress != null)

                    console.log('validation success');

            }

            //PROSES VALIDATION
            if (validation == false) {
                console.log("error : " + message);

                var SWALtranslate = $scope.SWALtranslate('validationinput');
                Swal.fire({
                    title: SWALtranslate.title,
                    text: SWALtranslate.message,
                    imageUrl: 'img/collection/wrong.png',
                    imageAlt: 'Preparation',
                    imageHeight: 250,
                    animation: false
                });
            }
        }
    }]);
